import './tokenomics.css';
export const Tokenomics = () => {
  return (
    <div id='tokenomics' className='text-center'>
      <div className='container'>
        <div>
          <div className='row'>
            <div className='col-md-10 col-md-offset-1 section-title'>
              <h2>Tokenomics</h2>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-6 col-md-3 tokenomics-item' data-aos="fade-up">
              <img src="../../img/icon1.png" alt="Limited Supply" />
              <h3>Limited Supply</h3>
              <span>327.000.000 RBY</span>
              <span>20,000 NFTs</span>
            </div>
            <div className='col-xs-6 col-md-3 tokenomics-item' data-aos="fade-up">
              <img src="../../img/icon2.png" alt="ERC-721 + ERC-20" />
              <h3>ERC-721 + ERC-20</h3>
            </div>
            <div className='col-xs-6 col-md-3 tokenomics-item' data-aos="fade-up">
              <img src="../../img/icon3.png" alt="Presale Date" />
              <h3>Presale Date</h3>
              <span>TBD</span>
            </div>
            <div className='col-xs-6 col-md-3 tokenomics-item' data-aos="fade-up">
              <img src="../../img/icon4.png" alt="Launch Date" />
              <h3>Launch Date</h3>
              <span>TBD</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
